var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.items,"rules":_vm.rules,"item-text":"name","item-value":"value","label":"Para Birimi","outlined":"","dense":""},on:{"input":_vm.onParaBirimiChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }